import { createTripletGlyphIcon } from '../../../utils/createTripletGlyphIcon';

/** Source: `svg-to-react-generator/source-svgs/outline/{S,M,L}/delete.svg` */
export const DeleteIcon = createTripletGlyphIcon('DeleteIcon', {
  s: () => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.334 3.12305C14.6375 3.12328 14.8838 3.36924 14.8838 3.67285C14.8838 3.97647 14.6375 4.22243 14.334 4.22266H13.0645V12.7861C13.0642 13.826 12.2206 14.6689 11.1807 14.6689H4.80566C3.76592 14.6687 2.92311 13.8259 2.92285 12.7861V4.22266H1.66797C1.36421 4.22266 1.11816 3.97661 1.11816 3.67285C1.11816 3.36909 1.36421 3.12305 1.66797 3.12305H14.334ZM4.02246 12.7861C4.02272 13.2184 4.37344 13.5691 4.80566 13.5693H11.1807C11.6131 13.5693 11.9636 13.2185 11.9639 12.7861V4.22266H4.02246V12.7861Z"
        fill="currentColor"
      />
      <path
        d="M10.4434 1.33105C10.7468 1.33132 10.9931 1.57735 10.9932 1.88086C10.9932 2.18445 10.7469 2.4304 10.4434 2.43066H5.54688C5.24312 2.43066 4.99707 2.18462 4.99707 1.88086C4.99717 1.57719 5.24318 1.33105 5.54688 1.33105H10.4434Z"
        fill="currentColor"
      />
    </svg>
  ),
  m: () => (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.125 3.58203C16.4287 3.58203 16.6757 3.82814 16.6758 4.13184C16.6758 4.43559 16.4288 4.68164 16.125 4.68164H14.6289V14.3838C14.6289 15.5158 13.711 16.4333 12.5791 16.4336H5.40723C4.27506 16.4336 3.35745 15.5159 3.35742 14.3838V4.68164H1.87598C1.57223 4.68162 1.32617 4.43558 1.32617 4.13184C1.32624 3.82815 1.57227 3.58205 1.87598 3.58203H16.125ZM4.45703 14.3838C4.45706 14.9084 4.88257 15.334 5.40723 15.334H12.5791C13.1035 15.3337 13.5293 14.9083 13.5293 14.3838V4.68164H4.45703V14.3838Z"
        fill="currentColor"
      />
      <path
        d="M11.748 1.56641C12.0517 1.5665 12.2979 1.81251 12.2979 2.11621C12.2979 2.41991 12.0517 2.66592 11.748 2.66602H6.23926C5.9357 2.66579 5.68945 2.41983 5.68945 2.11621C5.68945 1.8126 5.9357 1.56664 6.23926 1.56641H11.748Z"
        fill="currentColor"
      />
    </svg>
  ),
  l: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.5 4.75977C21.9142 4.75977 22.25 5.09555 22.25 5.50977C22.2497 5.92375 21.9141 6.25977 21.5 6.25977H19.5215V19.1787C19.5212 20.6972 18.29 21.9286 16.7715 21.9287H7.20898C5.69047 21.9286 4.45925 20.6972 4.45898 19.1787V6.25977H2.50098C2.08709 6.25957 1.75124 5.92363 1.75098 5.50977C1.75098 5.09567 2.08693 4.75996 2.50098 4.75977H21.5ZM5.95898 19.1787C5.95925 19.8688 6.5189 20.4286 7.20898 20.4287H16.7715C17.4616 20.4286 18.0212 19.8688 18.0215 19.1787V6.25977H5.95898V19.1787Z"
        fill="currentColor"
      />
      <path
        d="M15.6641 2.07129C16.0782 2.07129 16.4139 2.40719 16.4141 2.82129C16.4141 3.2355 16.0783 3.57129 15.6641 3.57129H8.31934C7.90523 3.57116 7.56934 3.23542 7.56934 2.82129C7.56947 2.40727 7.90532 2.07142 8.31934 2.07129H15.6641Z"
        fill="currentColor"
      />
    </svg>
  ),
});
